module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-accordion-item', {
    staticClass: "accordionForm",
    on: {
      "accordion:open": function($event) {
        _vm.openedAccordion = true
      },
      "accordion:close": function($event) {
        _vm.openedAccordion = false
      }
    }
  }, [_c('f7-accordion-toggle', {
    staticClass: "accordionToggle accordionTitleInformation boxRequest"
  }, [_c('div', {
    staticClass: "documentInformationGrid"
  }, [_c('div', [_c('div', {
    staticClass: "rowMainElement",
    class: _vm.getLabelColorClass(_vm.document.Status)
  }, [_vm._v("\r\n          " + _vm._s(_vm.shareholder !== false ?
    _vm.$t('doctypes.' + _vm.document.Type + '_general') :
    (
      (_vm.seller.LegalRepresentativeFirstname !== '' && _vm.seller.LegalRepresentativeLastname !== '') ?
      _vm.$t('doctypes.' + _vm.document.Type, {
        legalRepresentative: _vm.seller.LegalRepresentativeFirstname + ' ' + _vm.seller.LegalRepresentativeLastname
      }) :
      _vm.$t('doctypes.' + _vm.document.Type + '_legal_representative')
    )) + "\r\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "documentInfoAlignRight",
    class: _vm.docstatusclass[_vm.document.Status]
  }, [_c('i', {
    staticClass: "icon list-icon",
    class: _vm.getStatusIcon(_vm.document.Status)
  }), _vm._v("\r\n        " + _vm._s(_vm.getStatusLabel(_vm.document.Status, _vm.document.Role)) + "\r\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "filesRow"
  }, [(_vm.fileArray.length !== 0) ? _c('div', _vm._l((_vm.fileArray), function(file) {
    return _c('div', {
      staticClass: "documentInfoFileName"
    }, [_c('div', {
      staticClass: "d-flex justify-content-between w-100 no-gutter pr-0 align-items-right"
    }, [(_vm.showValidationButtonsLevel2(_vm.document.Status)) ? _c('div', {
      staticClass: "col-4 px-0"
    }, [_c('div', {
      staticClass: "documentButton mx-2",
      on: {
        "click": function($event) {
          return _vm.updateDecisionLevel2($event, _vm.document, 'ACCP')
        }
      }
    }, [_c('i', {
      staticClass: "icon list-icon icon-accept-doc"
    }), _vm._v("\r\n                  " + _vm._s(_vm.$t('common.accpt')) + "\r\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "documentButton mx-2",
      on: {
        "click": function($event) {
          return _vm.updateDecisionLevel2($event, _vm.document, 'RFSL')
        }
      }
    }, [_c('i', {
      staticClass: "icon list-icon icon-reject-doc"
    }), _vm._v("\r\n                  " + _vm._s(_vm.$t('common.refus')) + "\r\n                ")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ml-2 col-8 px-0"
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.downloadFile(file, $event)
        }
      }
    }, [_vm._v("\r\n                  " + _vm._s(file.Name) + "\r\n                ")])]), _vm._v(" "), (_vm.editableStatus.includes('Doc_' + _vm.document.Status)) ? _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.removeFile(file, $event)
        }
      }
    }, [_c('i', {
      staticClass: "icon button-delete f7-icons",
      staticStyle: {
        "margin-right": "-10px"
      }
    }, [_vm._v("close")])]) : _vm._e()])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.showUploadFile(_vm.document)) ? _c('div', [_c('div', {
    staticClass: "importFileButton showLargeScreenOnly",
    class: {
      uploadedDocumentsList: _vm.fileArray.length !== 0
    }
  }, [_c('span', {
    staticClass: "fileClickButton",
    on: {
      "click": function($event) {
        return _vm.openFileSelectionWindow($event)
      }
    }
  }, [_vm._v("\r\n              " + _vm._s(_vm.$t('common.add_file')) + "\r\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "importFileButton showSmallScreenOnly",
    class: {
      uploadedDocumentsList: _vm.fileArray.length !== 0
    },
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('span', {
    staticClass: "fileClickButton",
    on: {
      "click": function($event) {
        return _vm.openFileSelectionWindow($event)
      }
    }
  }, [_vm._v("\r\n              " + _vm._s(_vm.$t('common.add_file')) + "\r\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.institutionalSourceableDocuments.includes(_vm.document.Type) && !_vm.fileArray.length) ? _c('div', {
    staticClass: "importFileButton"
  }, [_c('span', {
    staticClass: "fileClickButton",
    on: {
      "click": function($event) {
        return _vm.callInstitutionalSource($event)
      }
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t('suppliers.ask_institut')) + "\r\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "accordionSoftOpener"
  })])])]), _vm._v(" "), _c('input', {
    ref: "fileButton",
    staticClass: "item-input hiddenElementAllSize local-file-input",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.executeOCR
    }
  }), _vm._v(" "), _c('f7-accordion-content', {
    staticClass: "background-supplier-document-form"
  }, [(_vm.hasOCRdata && _vm.editableStatus.includes('Doc_' + _vm.document.Status)) ? _c('div', {
    staticClass: "container-document-form"
  }, [(_vm.serializeGet.length != 0 && _vm.ocrDone) ? _c('b-row', _vm._l((_vm.serializeGet), function(value) {
    return _c('b-col', {
      key: value.name,
      staticClass: "form-group",
      attrs: {
        "sm": "6"
      }
    }, [_c('form-write-group-label-input', {
      attrs: {
        "idLabel": _vm.$t('businessDocuments.serialize.' + _vm.document.Type + '.' + value.name),
        "inputType": value.name === 'TypeIDCard' ? 'listeSelect' : 'text',
        "specificErrorIndicator": _vm.document.Serialize[value.name].Valid === '0',
        "warningIndicator": _vm.controlsConfig === '1' ? _vm.showWarningIndicator(value.name, _vm.document.Serialize) : false,
        "specificMessage": _vm.controlsConfig === '1' ? _vm.getAssociatedMessage(_vm.document.Serialize[value.name].Description) : ''
      },
      model: {
        value: (_vm.document.Serialize[value.name].Value),
        callback: function($$v) {
          _vm.$set(_vm.document.Serialize[value.name], "Value", $$v)
        },
        expression: "document.Serialize[value.name].Value"
      }
    }, [(value.name === 'TypeIDCard') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.document.Serialize[value.name]),
        expression: "document.Serialize[value.name]"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "sel2",
        "readonly": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.document.Serialize, value.name, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v(_vm._s(_vm.$t('businessDocuments.slct_doct_type')))]), _vm._v(" "), _c('option', {
      domProps: {
        "value": _vm.$t('businessDocuments.idcard_info.National_Identity_Card')
      }
    }, [_vm._v(_vm._s(_vm.$t('businessDocuments.idcard_info.National_Identity_Card')))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Passeport"
      }
    }, [_vm._v(_vm._s(_vm.$t('businessDocuments.idcard_info.Passport')))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Titre_sejour"
      }
    }, [_vm._v(_vm._s(_vm.$t('businessDocuments.idcard_info.Titre_sejour')))])]) : _vm._e()])], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-start"
  }, [_c('div', {
    staticClass: "col-md-4 offset-md-8"
  }, [_c('button', {
    staticClass: "button-action firstButtonMarginTop col-md milkyBlockBlack",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.uploadDocument
    }
  }, [_c('i', {
    staticClass: "icon fa fa-paper-plane"
  }), _vm._v("\r\n            " + _vm._s(_vm.shareholder !== false ?
    _vm.$t('suppliers.save_info_button') :
    _vm.$t('businessDocuments.validate_document_button')) + "\r\n          ")]), _vm._v(" "), _c('br'), _c('br')])])], 1) : (_vm.document.Serialize) ? _c('div', [_c('b-row', {
    staticClass: "container-document-form"
  }, _vm._l((_vm.document.Serialize), function(info, index) {
    return _c('b-col', {
      key: index,
      staticClass: "form-group",
      attrs: {
        "sm": "6"
      }
    }, [_c('form-read-group-label-input', {
      attrs: {
        "idLabel": _vm.$t('businessDocuments.serialize.' + _vm.document.Type + '.' + index),
        "inputValue": info
      }
    })], 1)
  }), 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-307cffee", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-307cffee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/detailPages/supplierDetailPages/DocumentGeneralInfo.vue
// module id = 2323
// module chunks = 2